define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UserService = void 0;
    class UserService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("users", httpProtocol, hostName, serviceName, proxyUrl);
        }
        authenticate(username, password) {
            let p = {};
            p.f = "application/json";
            p.u = username;
            p.p = password;
            return this.post("authenticate", p, (json) => {
                return json;
            });
        }
    }
    exports.UserService = UserService;
});
